/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum BladderIrrigationStartAliases {
  ACCORDION_INFORMATION = 'accordion-information',
  APPEARANCE_OF_LIQUID_AUTOCOMPLETE = 'appearance-of-liquid-autocomplete',
  APPEARANCE_OF_LIQUID_FETCH = 'appearance-of-liquid-fetch',
  APPEARANCE_OF_LIQUID_FIELD = 'appearance-of-liquid-field',
  APPEARANCE_OF_LIQUID_MAPPER = 'appearance-of-liquid-mapper',
  APPEARANCE_OF_LIQUID_TEXT = 'appearance-of-liquid-text',
  BLADDER_IRRIGATION_START_LAYOUT = 'bladder-irrigation-start-layout',
  BUTTON_EXECUTE = 'button-execute',
  CONTENT_INFORMATION_HEADER = 'content-information-header',
  DATE_HOUR_FIELD = 'date-hour-field',
  DATE_HOUR_INPUT = 'date-hour-input',
  DRAINED_VOLUME_FIELD = 'drained-volume-field',
  DRAINED_VOLUME_INPUT = 'drained-volume-input',
  GLOBAL_ACTIONS_EXECUTE = 'global-actions-execute',
  INFORMATION_FORM = 'information-form',
  INFORMATION_TEXT = 'information-text',
  INFUSED_VOLUME_FIELD = 'infused-volume-field',
  INFUSED_VOLUME_INPUT = 'infused-volume-input',
  IRRIGATION_OR_WASHING_GROUP_FIELD = 'irrigation-or-washing-group-field ',
  IRRIGATION_OR_WASHING_RADIO_GROUP = 'irrigation-or-washing-radio-group',
  NOTE_FIELD = 'note-field',
  NOTES_TEXT_AREA = 'notes-text-area',
  PANEL_ACCORDION_INFORMATION = 'panel-accordion-information',
  PANEL_FORM_INFORMATION = 'panel-form-information',
  PANEL_INFORMATION_HEADER = 'panel-information-header',
  TEXT_BLADDER_IRRIGATION_DATE = 'text-bladder-irrigation-date',
  TEXT_BLADDER_IRRIGATION_INFORMATION = 'text-bladder-irrigation-information',
}
export { BladderIrrigationStartAliases };
